import React from 'react'

const NotFound = React.lazy(() => import('@components/NotFound'))
const Home = React.lazy(() => import('@pages/Home'))
const Search = React.lazy(() => import('@pages/Search'))
const About = React.lazy(() => import('@pages/About'))
const Downloads = React.lazy(() => import('@pages/Downloads'))
const Detail = React.lazy(() => import('@pages/Detail'))
const Fold = React.lazy(() => import('@pages/Fold'))
const Statistics = React.lazy(() => import('@pages/Statistics'))
export const Layout = React.lazy(() => import('@components/Layout'))

const routes = [
  {
    path: '/404',
    exact: true,
    name: '404',
    uniqueKey: 'notFound',
    element: <NotFound />,
  },
  {
    path: '/',
    exact: true,
    name: '首页',
    uniqueKey: 'home',
    element: <Home />,
  },
  {
    path: '/search',
    exact: true,
    name: '搜索结果页',
    uniqueKey: 'search',
    element: <Search />,
  },
  {
    path: '/about',
    exact: true,
    name: '关于我们',
    uniqueKey: 'about',
    element: <About />,
  },
  {
    path: '/downloads',
    exact: true,
    name: '下载',
    uniqueKey: 'downloads',
    element: <Downloads />,
  },
  {
    path: '/fold',
    exact: true,
    hideHeader: true,
    hideFooter: true,
    name: 'fold',
    uniqueKey: 'fold',
    element: <Fold />,
  },
  {
    path: '/structure/:pdbId',
    exact: true,
    name: '结构',
    uniqueKey: 'structure',
    element: <Detail />,
  },
  {
    path: '/summary/:pdbId',
    exact: true,
    name: '概览',
    uniqueKey: 'summary',
    element: <Detail />,
  },
  {
    path: '/validation/:pdbId',
    exact: true,
    name: '验证',
    uniqueKey: 'validation',
    element: <Detail />,
  },
  {
    path: '/experiment/:pdbId',
    exact: true,
    name: '实验',
    uniqueKey: 'experiment',
    element: <Detail />,
  },
  {
    path: '/detail/:pdbId',
    exact: true,
    name: '详情',
    uniqueKey: 'detail',
    element: <Detail />,
  },
  {
    path: '/statistics',
    exact: true,
    name: '统计',
    uniqueKey: 'statistics',
    element: <Statistics />,
  },
  {
    path: '*',
    exact: true,
    name: 'redirectHome',
    uniqueKey: 'redirectHome',
    redirect: '/',
    element: {},
  },
]
export default routes
